<app-side-nav></app-side-nav>

<div class="content-wrapper">
  <app-nav-menu></app-nav-menu>
  <main>
    <alert></alert>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </main>
</div>